import React from 'react';

const priorityConfig = {
  pilny: { bg: 'var(--danger-light)', text: 'var(--danger)', label: 'Pilny', border: 'var(--danger-light)' },
  wazny: { bg: 'var(--warning-light)', text: 'var(--warning)', label: 'Wazny', border: 'var(--warning-light)' },
  normalny: { bg: 'var(--info-light)', text: 'var(--info)', label: 'Normalny', border: 'var(--info-light)' }
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('pl-PL', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
};

const MessageItem = ({
  message,
  isSelected,
  selectedFolder,
  isAdmin,
  authUser,
  canSendMessages,
  canDeleteMessages,
  onSelect,
  onReply,
  onDelete,
  onClose,
}) => {
  const priority = priorityConfig[message.priorytet] || priorityConfig.normalny;

  return (
    <div>
      <div
        onClick={() => onSelect(message)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '10px 12px',
          backgroundColor: isSelected ? 'var(--info-light)' : (!message.is_read ? 'var(--info-light)' : 'var(--card-bg)' ),
          borderRadius: '6px',
          border: `1px solid ${isSelected ? 'var(--info)' : 'var(--border)'}`,
          marginBottom: '6px',
          cursor: 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {!message.is_read && (
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: 'var(--info)', flexShrink: 0 }} />
        )}

        <div style={{ width: '4px', height: '28px', borderRadius: '2px', backgroundColor: priority.text, flexShrink: 0 }} />

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
            <span style={{ fontWeight: message.is_read ? 400 : 600, fontSize: '13px', color: 'var(--text)' }}>
              {message.tytul}
            </span>
            {message.is_global && (
              <span style={{ padding: '1px 6px', fontSize: '10px', borderRadius: '3px', backgroundColor: 'var(--success)20', color: 'var(--success)', fontWeight: 500 }}>
                GLOBAL
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '3px' }}>
            <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
              {selectedFolder === 'sent'
                ? `Do: ${message.odbiorca_login || message.location_name || 'Wszyscy'}`
                : `Od: ${message.nadawca_login}`}
            </span>
            <span style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{formatDate(message.created_at)}</span>
          </div>
        </div>

        <span style={{
          padding: '3px 8px', fontSize: '10px', fontWeight: 500,
          borderRadius: '3px', backgroundColor: priority.bg, color: priority.text,
          border: `1px solid ${priority.border}`, flexShrink: 0
        }}>
          {priority.label}
        </span>
      </div>

      {isSelected && (
        <div style={{
          padding: '16px',
          backgroundColor: 'var(--bg)',
          borderRadius: '6px',
          border: '1px solid var(--info)',
          borderTop: 'none',
          marginBottom: '6px',
          marginTop: '-6px',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        }}>
          <div style={{ marginBottom: '12px' }}>
            <h4 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--text)' }}>{message.tytul}</h4>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
              <span><strong>Od:</strong> {message.nadawca_login}</span>
              <span><strong>Do:</strong> {message.odbiorca_login || message.location_name || 'Wszyscy'}</span>
              <span><strong>Data:</strong> {formatDate(message.created_at)}</span>
            </div>
          </div>

          <div style={{
            padding: '12px', backgroundColor: "var(--card-bg)", borderRadius: '4px',
            border: '1px solid var(--border)', marginBottom: '12px',
            whiteSpace: 'pre-wrap', fontSize: '13px', lineHeight: '1.6'
          }}>
            {message.tresc}
          </div>

          {isAdmin && message.read_by && message.read_by.length > 0 && (
            <div style={{ marginBottom: '12px', padding: '10px', backgroundColor: 'var(--success-light)', borderRadius: '4px', fontSize: '12px' }}>
              <strong>Przeczytane przez:</strong>
              <div style={{ marginTop: '4px' }}>
                {message.read_by.map((read, idx) => (
                  <div key={idx} style={{ color: 'var(--success)' }}>
                    {read.user_login} - {formatDate(read.read_at)}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{ display: 'flex', gap: '8px' }}>
            {selectedFolder !== 'sent' && canSendMessages && (
              <button
                onClick={() => onReply(message)}
                style={{ padding: '6px 12px', border: '1px solid var(--success)', color: 'var(--success)' , cursor: 'pointer', fontSize: '12px', fontWeight: 500 }}
              >
                Odpowiedz
              </button>
            )}
            {(isAdmin || (canDeleteMessages && message.nadawca_login === authUser?.login)) && (
              <button
                onClick={() => onDelete(message.id)}
                style={{ padding: '6px 12px', border: '1px solid var(--danger)', color: 'var(--danger)' , cursor: 'pointer', fontSize: '12px', fontWeight: 500 }}
              >
                Usun
              </button>
            )}
            <button
              onClick={onClose}
              style={{ padding: '6px 12px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' , cursor: 'pointer', fontSize: '12px' }}
            >
              Zamknij
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageItem;
